var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var currentLang = "en";
import { t } from '@mp/locale';
export function setLanguage(lang) {
    currentLang = lang;
}
export function formatPreferredStartTime(startTime, timeZone, options) {
    var date = startTime.toLocaleDateString(currentLang, {
        weekday: (options === null || options === void 0 ? void 0 : options.longDay) ? "long" : "short",
        month: "short",
        day: "numeric",
        timeZone: timeZone,
    });
    var time = startTime.toLocaleTimeString(currentLang, {
        hour: "numeric",
        minute: "numeric",
        timeZone: timeZone,
    });
    var timezone = new Intl.DateTimeFormat(currentLang, {
        timeZone: timeZone,
        timeZoneName: "short",
    })
        .format(startTime)
        .split(" ")[1];
    return t("CAPTURE_SERVICES.SCHEDULER.formattedDateTime", null, {
        date: date,
        time: time,
        timezone: timezone,
    });
}
export function formatSlot(slotItemDatetime, timeZone, slotItem) {
    return __assign(__assign({}, slotItem), { datetime: slotItemDatetime, formatted: slotItemDatetime.toLocaleTimeString(currentLang, {
            hour: "numeric",
            minute: "numeric",
            timeZone: timeZone,
        }), formattedDateTime: slotItemDatetime.toLocaleString(currentLang, {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            timeZone: timeZone,
        }) });
}
export function formatDates(initialDate, availableDates, timeZone) {
    var formattedDates = [];
    var _loop_1 = function (i) {
        var date = new Date(initialDate);
        date.setDate(initialDate.getDate() + i);
        var availableDate = availableDates.find(function (item) {
            var itemDate = new Date(item.date);
            return itemDate.toDateString() == date.toDateString();
        });
        if (!availableDate) {
            return "continue";
        }
        date = new Date(availableDate.date);
        var availableSlots = [];
        availableDate.availableSlots.forEach(function (slotItem) {
            var slotItemDatetime = new Date(slotItem.startTime);
            availableSlots.push(formatSlot(slotItemDatetime, timeZone, slotItem));
        });
        var formattedDate = {
            date: date,
            formatted: {
                day: date.toLocaleDateString(currentLang, { day: "2-digit", timeZone: timeZone }),
                weekday: date.toLocaleDateString(currentLang, {
                    weekday: "short",
                    timeZone: timeZone,
                }),
                month: date.toLocaleDateString(currentLang, {
                    month: "short",
                    timeZone: timeZone,
                }),
            },
            disabled: !availableSlots.length,
            availableSlots: availableSlots,
        };
        formattedDates.push(formattedDate);
    };
    for (var i = 0; i < 7; i++) {
        _loop_1(i);
    }
    return formattedDates;
}
export function getDuration(totalMinutes) {
    var hours = Math.floor(totalMinutes / 60);
    var minutes = totalMinutes % 60;
    if (!totalMinutes) {
        return "0";
    }
    if (hours < 2) {
        return t("CAPTURE_SERVICES.ORDER.SCHEDULE.duration.minutes", null, {
            minutes: totalMinutes,
        });
    }
    if (!minutes) {
        return t("CAPTURE_SERVICES.ORDER.SCHEDULE.duration.hours", null, { hours: hours });
    }
    return t("CAPTURE_SERVICES.ORDER.SCHEDULE.duration.hoursAndMinutes", null, {
        hours: hours,
        minutes: minutes,
    });
}
